import { lazy } from "react";
// ===========================================================================
// Pre-Visit Planning Module — Medical Receptionist (Módulo D — BillingV2)
// Huddle sheet por cita: HCCs sospechosos, care gaps, meds y labs antes de la visita.
//
// SPLIT POR ROL (2026-09-14): este módulo quedó como el del MEDICAL
// RECEPTIONIST (checklist administrativo). El del MEDICAL ASSISTANT (checklist
// clínico) es una réplica en `previsit-planning-ma` (/previsit-planning-ma) que
// va a evolucionar por su cuenta. Ambos escriben en el MISMO backend
// (TAB_APPOINTMENT_REV + TAB_PREVISIT_CHECKLIST), cada uno con su clave de
// rol ("receptionist" / "assistant") — el dato sigue compartido.
//
// ACCESO: lo gobierna la matriz RBAC y NADA MÁS — módulo `previsit_planning`
// (25) del catálogo, mapeado en app/AccessDenied/roleRoutePermissions.js.
// Quien tenga el módulo concedido entra; el sidebar y el RoleGuard usan ese
// mismo gate.
//
// 2026-08-31: se retiró `PrevisitGuardedRoute`, que exigía ADEMÁS estar en la
// allowlist de empleados (REACT_APP_PREVISIT_EMPLOYEES). Mientras el módulo no
// estaba en el catálogo esa lista era el único control posible, pero al
// registrarse pasó a ser un segundo gate invisible: conceder el módulo desde
// Access Control no alcanzaba y el usuario caía en /AccessDenied sin
// explicación. El propio comentario del módulo pedía retirarla al llegar acá.
//
// OJO — lo que la allowlist SÍ sigue haciendo (ver common/providerAccess.js):
// el mapa empleado → profileId de AdvancedMD decide QUÉ citas ve cada uno. Un
// médico mapeado ve solo las suyas; quien no está en el mapa ve la jornada
// completa. Eso es alcance de datos, no acceso al módulo, y sigue vigente.
// ===========================================================================

// Lazy: nada del módulo viaja en el bundle inicial. AppRouter provee el Suspense.
const PrevisitPlanningPage = lazy(() => import("./pages/PrevisitPlanningPage"));

export const previsitPlanningRoutes = [
  {
    path: "/previsit-planning",
    element: <PrevisitPlanningPage />,
  },
];

// Export components for external use

// Export utilities
export * from "./common/constants";
